import React, { useContext, useEffect, useRef, useState } from "react";
import { fetchPiggy } from "../../firebase/docs";
import AddRecord from "../AddRecord";
import UserContext from "../../context/user/UserContext";
import PiggyContext from "../../context/piggy/PiggyContext";
import DeleteRecord from "../DeleteRecord";

function Dashboard() {
  const userContext = useContext(UserContext);
  const piggyContext = useContext(PiggyContext);
  const containerRef = useRef();
  const [total, setTotal] = useState(0);

  useEffect(() => {
    const runFetchPiggy = async () => {
      const data = await fetchPiggy(userContext.user.uid);
      piggyContext.setRows(data);
    };
    const setTableHeight = () => {
      const topNav = document.getElementById("main-navbar");

      const winHeight = window.innerHeight; // Window height in px
      const topNavHeightAndPadding = topNav.offsetHeight; // Navbar height + padding in px
      const topNavMarginBottom = 24; // Margin bottom to be manually written in px
      const topNavTotalHeight = topNavHeightAndPadding + topNavMarginBottom;
      const height = winHeight - topNavTotalHeight - 24; // -24 act as a bottom margin of 24px

      containerRef.current.style.maxHeight = `${height}px`;
    };

    document.title = "Centerio - Dashboard";
    runFetchPiggy();
    setTableHeight();
    window.onresize = setTableHeight;
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let tempTotal = 0;
    piggyContext.rows.forEach((elem) => {
      if (elem.status.toLowerCase() === "increase") tempTotal += elem.amount;
      else tempTotal -= elem.amount;
    });
    setTotal(tempTotal);
  }, [piggyContext.rows]);

  return (
    <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
      <div
        ref={containerRef}
        className="h-inherit flex w-full flex-col rounded-sm border border-gray-200 bg-white shadow-lg"
      >
        <header className="flex justify-between border-b border-gray-100 py-4 px-3">
          <h2 className="font-semibold text-gray-800">Savings Table</h2>
          <h3 className="pr-2 font-normal text-gray-800">
            TOTAL: <span className="font-semibold">₹{total}</span>
          </h3>
        </header>
        <div className="bg-red-8 tableContainer relative h-full overflow-y-scroll px-3">
          <table className="w-full table-auto">
            <thead className="sticky top-0 z-10  text-sm font-semibold uppercase leading-6 text-gray-400">
              <tr>
                <th className="h-2.5 bg-white" />
                <th className="h-2.5 bg-white" />
                <th className="h-2.5 bg-white" />
                <th className="h-2.5 bg-white" />
              </tr>
              <tr className="bg-gray-50">
                <th className="whitespace-nowrap rounded-l-md p-2">
                  <div className="text-left font-semibold">Source</div>
                </th>
                <th className="whitespace-nowrap p-2">
                  <div className="text-center font-semibold">Amount</div>
                </th>
                <th className="whitespace-nowrap p-2">
                  <div className="text-center font-semibold">Date</div>
                </th>
                <th className="whitespace-nowrap rounded-r-md p-2">
                  <div className="text-center font-semibold">Action</div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-sm">
              {piggyContext.rows.map((row) => (
                <tr key={row.id}>
                  <td className="whitespace-nowrap p-2">
                    <div className="text-md text-left font-medium text-gray-800">
                      {row.source}
                    </div>
                  </td>
                  <td className="whitespace-nowrap p-2">
                    <div
                      className={`text-md text-center font-normal ${
                        row.status.toLowerCase() === "increase"
                          ? "text-green-500"
                          : "text-red-500"
                      }`}
                    >
                      ₹{row.amount}
                    </div>
                  </td>
                  <td className="whitespace-nowrap p-2">
                    <div className="text-md text-center font-normal text-gray-800">
                      {row.date.toDate().toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </div>
                  </td>
                  <td className="whitespace-nowrap p-2">
                    <div className="text-md flex justify-center gap-5 text-center font-normal text-gray-800">
                      <DeleteRecord id={row.id} />
                      {/* TODO: Implement edit btn */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <AddRecord />
        </div>
      </div>

      {/* TODO: Implement bottom navbar */}
    </div>
  );
}

export default Dashboard;
